import styled from 'styled-components';

export const ScCustomArrows = styled.div`
  display: flex;
`;

export const ScCustomArrowLeft = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
`;

export const ScCustomArrowRight = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
`;
